module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_7016.3db7e87e.png";